module.exports = __webpack_public_path__ + "img/undo.10dc1b03.svg";